module.exports = __webpack_public_path__ + "img/qunaer.74e9786b.jpg";